<template>
  <div class="aco-info-box">
    <b-col class="aco-details">
      <b-form>
        <fieldset :disabled="loading">
          <b-row class="aco-details-row">
            <b-col>
              <b-row>
                <b-col><h5>{{ $t('pendingOnixFiles') }}</h5></b-col>
              </b-row>
              <b-table show-empty striped hover small class="aco-table"
                       :items="onixFiles" :fields="onixFileFields">
                <template slot="empty">
                  <div class="text-center">{{ $t('emptyTable') }}</div>
                </template>
                <template v-slot:cell(download)="row">
                  <b-button variant="link" size="sm" v-on:click="downloadOnixFile(row.item.filename)">{{ $t('download') }}</b-button>
                </template>
                <template v-slot:cell(process)="row">
                  <b-button variant="link" size="sm" v-on:click="processFile(row.item.filename)">{{ $t('process') }}</b-button>
                </template>
                <template v-slot:cell(archive)="row">
                  <b-button variant="link" size="sm" v-on:click="archiveOnixFile(row.item.filename)">{{ $t('archive') }}</b-button>
                </template>
              </b-table>

              <b-row>
                <b-col><h5>{{ $t('archivedOnixFiles') }}</h5></b-col>
              </b-row>
              <b-table show-empty striped hover small class="aco-table"
                       :items="archivedFiles" :fields="archivedFileFields">
                <template slot="empty">
                  <div class="text-center">{{ $t('emptyTable') }}</div>
                </template>
                <template v-slot:cell(download)="row">
                  <b-button variant="link" size="sm" v-on:click="downloadArchivedFile(row.item.filename)">{{ $t('download') }}</b-button>
                </template>
                <template v-slot:cell(unarchive)="row">
                  <b-button variant="link" size="sm" v-on:click="unArchiveOnixFile(row.item.filename)">{{ $t('backToProcessing') }}</b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </fieldset>
      </b-form>
    </b-col>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'BiblioOnixImport',
    extends: BaseComponent,

    computed: {
      ...mapGetters('biblioOnix', ['onixFiles', 'archivedFiles', 'loading']),
      ...mapGetters('languageStore', ['langCode']),
      archivedFileFields () {
        return [
          { key: 'filename', label: this.$t('filename') },
          { key: 'size', label: this.$t('size'), formatter: value => this.formatFilesize(value) },
          { key: 'modified', label: this.$t('modified'), formatter: value => this.formatTimestamp(value) },
          { key: 'download', label: '' },
          { key: 'unarchive', label: '' }
        ]
      },
      onixFileFields () {
        return [
          { key: 'filename', label: this.$t('filename') },
          { key: 'size', label: this.$t('size'), formatter: value => this.formatFilesize(value) },
          { key: 'modified', label: this.$t('modified'), formatter: value => this.formatTimestamp(value) },
          { key: 'download', label: '' },
          { key: 'process', label: '' },
          { key: 'archive', label: '' }
        ]
      }
    },

    created: function () {
      this.$store.dispatch('biblioOnix/getOnixFiles')
      this.$store.dispatch('biblioOnix/getArchivedFiles')
    },

    methods: {
      downloadOnixFile (onixFile) {
        this.downloadFile(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/' + onixFile, onixFile)
      },
      downloadArchivedFile (archivedFile) {
        this.downloadFile(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/archive/' + archivedFile, archivedFile)
      },
      processFile (onixFile) {
        this.$store.dispatch('biblioOnix/processOnixFile', onixFile)
      },
      archiveOnixFile (onixFile) {
        this.$store.dispatch('biblioOnix/archiveOnixFile', onixFile)
      },
      unArchiveOnixFile (archiveFile) {
        this.$store.dispatch('biblioOnix/unArchiveOnixFile', archiveFile)
      }
    },

    i18n: {
      messages: {
        en: {
          'administerOnixFiles': 'Administer Biblio ONIX files',
          'pendingOnixFiles': 'ONIX files pending import',
          'archivedOnixFiles': 'Archives ONIX files',
          'archive': 'Archive',
          'backToProcessing': 'Back to processing'
        },
        nb: {
          'administerOnixFiles': 'Administrere Biblio ONIX filer',
          'pendingOnixFiles': 'ONIX filer til behandling',
          'archivedOnixFiles': 'Arkiverte ONIX filer',
          'archive': 'Arkiver',
          'backToProcessing': 'Tilbake til behandling'
        }
      }
    }
  }
</script>